import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, { CSVExport, Search, } from "react-bootstrap-table2-toolkit";
import { faDownload} from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { getDealerDDFWorkOrderR, getDealerWiseInstallationReport } from "../../Service/AllReportAPI";

import Axios from "../../utils/axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Select from "react-select";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import fileSaver from "file-saver";
import { getDealerList } from "../master/AllUserDropDown";
import { getWorkOrderCalibrationList, } from "../../Service/AllWorkOrderCalibrationAPI";
import moment from "moment";
import swal from "sweetalert";

//import * as Yup from "yup";

export default () => {
  const { SearchBar } = Search;
  const [entries, setEntries] = useState([]);
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });

  const [dealerName, setDealerName] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState("");
  const [isLoaded, setisLoaded] = useState(false);

  // --- pagination
  const [state, setState] = useState({});
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);


  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    console.log("selectedPage", selectedPage);
    if (selectedDealer === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getWorkOrderCalibrationList( selectedPage, "calibration", fkUserId, role, headers )
      .then((result) => {
        console.log("Get Pagination calibration Result", result);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          console.log("data", data);
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotaloffset(totalSize);
          entries.map((item, index) => (item.id = totalSize + index + 1));
        } else {
          swal("Sorry", "Data is not present", "warning");
        }
      })
      .catch((error) => console.error("Error", error));
    } else if (selectedDealer !== "") {
      await getDealerWiseInstallationReport(selectedPage,selectedDealer,"calibration")
      .then((result) => {
        console.log("Get Dealer wise calibration Result", result);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          entries.map((item, index) => (item.id = totalSize + index + 1));
          console.log("totalSize", totalSize);
          console.log("data", data);
          setEntries(data);
          setTotaloffset(totalSize);
          setTotalCount(result.data.totalElements);
        } else {
          swal("Sorry", "Data is not present", "warning");
        }
      })
      .catch((error) => {
        console.log("Get Field Issue Error", error);
      });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };
  useEffect(() => {
    // Function call to get Dispatch list
    getCalibration();
    getDealerDDFWorkOrderRList();
    // eslint-disable-next-line
  }, []);

  const getDealerDDFWorkOrderRList = async () => {
    let token = sessionStorage.getItem("token");
    let headers = {Authorization: `Bearer ${token}`}
    let jobType = ["calibration"];
    await getDealerDDFWorkOrderR(headers, jobType)
    .then((result) => {
      console.log("getDealerDDFWorkOrderRList Calibration result :-", result);
      let dealerDD = [];
      let tempDealerDDArray = result.data.map((obj) => {
        let dealer = obj.split(",");
        return {
          id: `${dealer[0]}`,
          value: `${dealer[1]}`,
          label: `${dealer[1]}`,
        };
      });
      dealerDD = tempDealerDDArray;
      setDealerName(dealerDD);
      console.log("getDealerDDFDEalerList Calibration dealerrDD", dealerDD);
    })
    .catch((error) => {
      console.log("getDealerDDFWorkOrderRList Calibration error :-", error);
    })
  };
   // Function declaration of get calibration list
  const getCalibration = async () => {
    try {
      setisLoaded(true);
      const role = sessionStorage.getItem('role');
      const fkUserId = sessionStorage.getItem('pkUserId');
      const token = sessionStorage.getItem("token");
      const headers= {"Authorization" : `Bearer ${token}`}
      await getWorkOrderCalibrationList(currentPage, "calibration", fkUserId, role, headers)
      .then((result) => {
        setisLoaded(false);
        console.log("Work Order Dealer Wise Calibration Result List", result);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotalCount(result.data.totalElements);
        }  else {
          setEntries([]);
          setPageCount();
          setTotalCount();
        }
      })
      .catch((error) => {
        console.log("Work Order Dealer Wise Calibration Error", error);
      });
    } catch (error) {
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  const getDealerWisePdfDownload = async (e) => {
    try {
      if (selectedDealer !== "") {
        setisLoaded(true);
        let role = sessionStorage.getItem('role');
        let fkUserId = sessionStorage.getItem('pkUserId');
        let token = sessionStorage.getItem("token");
        let jobType = ["calibration"];
        let fileType = ["Pdf"];
        return Axios.get(
          `dealerNameWiseWorkOrderReportPdf?fileType=${fileType}&dealerName=${selectedDealer}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          setisLoaded(false);
          var blob = new Blob([response.data], { type: "application/pdf" });
          fileSaver.saveAs(blob, `dealernamewisecalibrationreport.pdf`);
        });
      } else {
        swal("Failed", "Please select Customer Name", "error");
      }
    } catch (error) {
      setisLoaded(false);
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  const getDealerWiseExcelDownload = async (e) => {
    try {
      if (selectedDealer !== "") {
        let role = sessionStorage.getItem('role');
        let fkUserId = sessionStorage.getItem('pkUserId');
        let token = sessionStorage.getItem("token");
        let jobType = ["calibration"];
        let fileType = ["Excel"];
        return Axios.get(
          `dealerNameWiseWorkOrderReportPdf?fileType=${fileType}&dealerName=${selectedDealer}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          fileSaver.saveAs(blob, `dealernamewiseworkordercalibration.xlsx`);
        });
      } else {
        swal("Failed", "Please select Customer Name", "error");
      }
    } catch (error) {
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));

  // Column heading of calibration list
  const columns = [
    { dataField: "id", text: "Sr. No." },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser Sr No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "workOrderSerialNo",
      text: "Work Order No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "calibrationDate",
      text: "Date",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>
            {moment(cell).format("DD-MMM-YYYY")}
          </>;
      },
    },
    {
      dataField: "calibrationTime",
      text: "Time",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>
            {moment(cell, 'hh:mm A').format('hh:mm A')}
          </>
      },
    },
    {
      dataField: "customerName",
      text: "Customer Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "dealerName",
      text: "Dealer Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "serviceEngineerName",
      text: "Service Engineer Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "serviceEngineerMobNo",
      text: "Service Engineer Mobile No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "email",
      text: "Email",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "dispenserType",
      text: "Dispenser Type",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "siteType",
      text: "Site Type",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "address",
      text: "Site Address",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => (
        <div className="content-cell">
          <span>{cell}</span>
        </div>
      )
    },
  ];

  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {from} to {to} of {size} entries
    </div>
  );

  // callback function when page was changing
  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <Formik
          initialValues={{}}
          onSubmit={async (values) => {
            console.log(JSON.stringify(values, null, 2));
          }}
        >
          {(formik) => {
            return (
              <>
                <Row>
                <div>
                    <h5 className="headNew mb-4">Dealer Name Wise Report</h5>
                </div>
                  <Col md={6} className="mb-3">
                    <div className="form-group">
                      <label className="Label mb-1" >Dealer Name</label>
                      <Select
                        id="dealerName"
                        placeholder="Select Dealer Name"
                        title="Select Dealer Name"
                        options={dealerName}
                        onChange={async(e) => {
                          formik.setFieldValue(currentPage,"dealerName", e.value);
                          setSelectedDealer(e.value);
                          await getDealerWiseInstallationReport(currentPage,e.value,"calibration")
                          .then((result) => {
                            console.log("Dealer Details", result.data);
                            if (result?.data?.content?.length !== 0) {
                              const data = result.data.content;
                              setEntries(data);
                              setPageCount(result.data.totalPages);
                              setTotalCount(result.data.totalElements);
                            } else {
                              setEntries([]);
                              setPageCount();
                              setTotalCount();
                              swal("Sorry", "Data is not present", "warning");
                            }
                          })
                          .catch((error) => {
                            console.log("Dealer Error", error);
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
{/* --- When you use any toolkit functionalities, you are supposed to render toolkit component and
  BootstrapTable as the children of ToolkitProvider --- */}
                <ToolkitProvider
                  keyField="id"
                  search={true}
                  columns={columns}
                  data={entries}
                  exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                >
                  {({ baseProps, searchProps, csvProps }) => (
                    //render the Pagination component as a list with left and right arrows
                    <Paginator.PaginationProvider
                      pagination={Pagination({
                        custom: true,
                        disablePageTitle: true,
                        alwaysShowAllBtns: true,
                        totalSize: totalCount,
                        paginationTotalRenderer: customTotal,
                        onPageChange : handlePageChange,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <Card>
                          <div className="table-responsive py-2">
                            <Card.Header>
                              <Row>
                                <Col xs={12} md={6} className="py-1">
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end py-1"
                                >
                                  <button
                                    className="btn btn-secondary mx-2"
                                    onClick={getDealerWisePdfDownload}
                                  >
                                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                                    <span>PDF</span>{" "}
                                  </button>
                                  <button
                                    className="btn btn-secondary"
                                    onClick={getDealerWiseExcelDownload}
                                  >
                                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                                    <span>Excel</span>
                                  </button>
                                </Col>
                              </Row>
                            </Card.Header>
                            <Table
                              {...baseProps}
                              {...paginationTableProps}
                              bodyClasses="border-0"
                              rowClasses="border-bottom"
                              classes="table-flush dataTable-table"
                            // selectRow={selectRow}
                              filter={filterFactory()}
                              headerClasses="header-class"
                              hover
                              striped
                              condensed
                              remote= {{pagination:true}}
                              cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                afterSaveCell: (
                                  oldValue,
                                  newValue,
                                  row,
                                  column
                                ) => {
                                  const changeRowData = {
                                    selectedRow: row,
                                    cellChange: newValue,
                                    columnChange: column,
                                  };
                                  setChangeRowData(changeRowData);
                                },
                              })}
                              wrapperClasses="table-responsive"
                            />
                            <Card.Footer>
                              <Row>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex align-items-center py-1"
                                >
                                    {/* <Paginator.PaginationTotalStandalone
                            {...paginationProps}
                          /> */}
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                                >
                                  <Paginator.PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </Card.Footer>
                          </div>
                        </Card>
                      )}
                    </Paginator.PaginationProvider>
                  )}
                </ToolkitProvider>
              </>
            );
          }}
        </Formik>
      )}
    </>
  );
};
// }};
